import BikeComparer from 'modules/bikeComparer';

export default {
	init() {
		BikeComparer.init();
	},
};
